var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.5C2 11.7044 2.31607 10.9413 2.87868 10.3787C3.44129 9.81607 4.20435 9.5 5 9.5H11C11.7956 9.5 12.5587 9.81607 13.1213 10.3787C13.6839 10.9413 14 11.7044 14 12.5C14 12.8978 13.842 13.2794 13.5607 13.5607C13.2794 13.842 12.8978 14 12.5 14H3.5C3.10218 14 2.72064 13.842 2.43934 13.5607C2.15804 13.2794 2 12.8978 2 12.5Z",
    stroke: "#7B7B7B",
    strokeWidth: 1.33,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.5C9.24264 6.5 10.25 5.49264 10.25 4.25C10.25 3.00736 9.24264 2 8 2C6.75736 2 5.75 3.00736 5.75 4.25C5.75 5.49264 6.75736 6.5 8 6.5Z",
    stroke: "#7B7B7B",
    strokeWidth: 1.33
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCustomer);
export default __webpack_public_path__ + "static/media/icon-customer.f85fb14a0394b1abf10efff3a5ce103f.svg";
export { ForwardRef as ReactComponent };